(function (_, kotlin_com_russhwolf_multiplatform_settings) {
  'use strict';
  //region block: imports
  var JsSettings_init_$Create$ = kotlin_com_russhwolf_multiplatform_settings.$_$.a;
  //endregion
  //region block: pre-declaration
  //endregion
  function Settings() {
    return JsSettings_init_$Create$(null, 1, null);
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Settings;
  //endregion
  return _;
}(module.exports, require('./MultiplatformSettings-multiplatform-settings-js-ir.js')));

